import request from '@/utils/request'

let DictApi = {

  /*字典配置列表*/
  list(data) {
    return request._post('/shop/plus.dict.Index/index', data);
},
/*添加字典配置*/
add(data) {
    return request._post('/shop/plus.dict.Index/add', data);
},
/*修改字典配置*/
edit(data) {
    return request._post('/shop/plus.dict.Index/edit', data);
},
/*删除字典配置*/
del(data) {
    return request._post('/shop/plus.dict.Index/del', data);
},
/*字典配置详情*/
detail(data) {
  return request._post('/shop/plus.dict.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.dict.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.dict.Setting/getSetting', data, errorback);
    },
       editPart(data) {
        return request._post('/shop/plus.dict.Index/editPart', data);
    },
}
export default DictApi;



// WEBPACK FOOTER //
// ./src/api/dict.js